import React, { SyntheticEvent, useState } from "react";
import {
  Avatar,
  Box,
  ClickAwayListener,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Snackbar,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import ShareLink from "../sharelink/sharelink";
import { InfoOutlined as InfoOutlinedIcon } from "@mui/icons-material";
import pricetagIcon from "../../assets/price-tag.png";
import { LOCALIZATION } from "../../utils/localization";
import { t } from "i18next";
import "./ServiceInfo.scss";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ShowMoreShowLess from "../ShowMoreShowLess/ShowMoreShowLess";
import BoldText from "../boldText/BoldText";

function ChadavaPackageService(props: any) {
  const {
    pujaName,
    offerActualPrice,
    finalPrice,
    urlToShare,
    tithiName,
    description,
    couponCodeText,
    currencySymbols,
  } = props;

  // POPUP Open on HOVER
  const [isPopUpOpen, setIsPopUpOpen] = useState(false);
  const [open, setOpen] = useState<boolean>(false);

  const handlePriceInfoOpen = () => setIsPopUpOpen(true);
  const handlePriceInfoClose = () => setIsPopUpOpen(false);


  const handleClose = (event: SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  return (
    <>
      <Box className="pujaDescription">
        <Box className="nameLocPrice">
          <List>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              className="twoItem"
            >
              <Box className="pujaNameInfo">
                <Typography>{pujaName}</Typography>
              </Box>
              <Box className="shareIcon">
                <ShareLink urlToShare={urlToShare} type="Chadhava Package"></ShareLink>
              </Box>
            </Stack>

            <ListItem>
              <ListItemAvatar sx={{ minWidth: "35px" }}>
                <Avatar alt="Tithi Icon" className="squreShape tithi">
                  <CalendarMonthIcon sx={{ color: "#d56939" }} />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={<BoldText text={tithiName} />}
                primaryTypographyProps={{ fontWeight: 500 }}
              />
            </ListItem>

            <ListItem>
              <ListItemAvatar sx={{ minWidth: "35px" }}>
                <Avatar alt="Pricetag Icon" className="squreShape pricetag">
                  <img src={pricetagIcon} alt="Price tag Icon" />
                </Avatar>
              </ListItemAvatar>

              <ListItemText
                className="chadhavaPackagePriceInfo"
                sx={{ flex: "0 0 auto" }}
                primary={
                  <>
                    <Typography component="span" className="currentPrice">
                      {currencySymbols || "₹"}{" "}
                      {finalPrice?.toLocaleString("en-IN")}
                    </Typography>
                    {offerActualPrice > 0 && (
                      <Typography component="span" className="previousPrice">
                        {currencySymbols || "₹"}{" "}
                        {offerActualPrice?.toLocaleString("en-IN")}
                      </Typography>
                    )}
                  </>
                }
              />

              <Box className="infoContainer">
                <ClickAwayListener onClickAway={handlePriceInfoClose}>
                  <Box>
                    <InfoOutlinedIcon
                      className="infoIcon"
                      onClick={handlePriceInfoOpen}
                      onMouseEnter={handlePriceInfoOpen}
                    />
                    {isPopUpOpen && (
                      <Box
                        className="popupBox"
                        onMouseLeave={handlePriceInfoClose}
                      >
                        <Typography className="messageTitle">
                          {t(LOCALIZATION.Price)}
                        </Typography>
                        <Typography className="messageText">
                          {t(
                            LOCALIZATION.The_price_does_not_include_Prasad_delivery
                          )}
                        </Typography>
                      </Box>
                    )}
                  </Box>
                </ClickAwayListener>
              </Box>
            </ListItem>

            <ListItem>
              <Box className="bottomDescription">
                <ShowMoreShowLess text={description}
                limit={useMediaQuery("(max-width:600px)") ? 30 : 200}/>
              </Box>
            </ListItem>
          </List>
        </Box>
        <Snackbar
          open={open}
          autoHideDuration={6000}
          onClose={handleClose}
          message="Coupon code copied "
        />
      </Box>
    </>
  );
}

export default ChadavaPackageService;
